module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav-bar'), _vm._v(" "), _c('div', {
    staticClass: "sidebar bg-darkgrey navbar-inverse side-box-shadow"
  }, [_c('ul', {
    staticClass: "nav flex-column"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('span', {
    staticClass: "nav-link navbar-text pull-left",
    class: {
      'current': _vm.current === 'addressBook'
    },
    on: {
      "click": function($event) {
        _vm.current = 'addressBook'
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('AddressBook.sidebar.address_book')) + "\n        ")])]), _vm._v(" "), (_vm.$store.state.userInfo && _vm.$store.state.userInfo.isSageOne) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('span', {
    staticClass: "nav-link navbar-text pull-left",
    class: {
      'current': _vm.current === 'sageOne'
    },
    on: {
      "click": function($event) {
        _vm.current = 'sageOne'
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('AddressBook.sidebar.sageone')) + "\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.userInfo && _vm.$store.state.userInfo.isSageOne) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('span', {
    staticClass: "nav-link navbar-text pull-left",
    class: {
      'current': _vm.current === 'linkTrans'
    },
    on: {
      "click": function($event) {
        _vm.current = 'linkTrans'
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('AddressBook.sidebar.linkTrans')) + "\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.userInfo && _vm.$store.state.userInfo.isSageOne) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('span', {
    staticClass: "nav-link navbar-text pull-left",
    class: {
      'current': _vm.current === 'linkDeal'
    },
    on: {
      "click": function($event) {
        _vm.current = 'linkDeal'
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('AddressBook.sidebar.linkDeal')) + "\n        ")])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-kne-orange col-12 mt-3",
    attrs: {
      "id": "addCustomer"
    },
    on: {
      "click": function($event) {
        _vm.add = true;
        _vm.clear()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n        " + _vm._s(_vm.$t('AddressBook.sidebar.add')) + "\n      ")]), _vm._v(" "), _c('json-excel', {
    staticClass: "btn btn-kne-orange col-12 mt-3",
    attrs: {
      "data": JSON.parse(JSON.stringify(_vm.customers)),
      "fields": _vm.customers_fields,
      "name": "addressBook.xls"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('AddressBook.sidebar.excel')) + "\n      ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "font-grey view"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.current === 'addressBook') ? _c('div', {
    key: "addressBook",
    staticClass: "card"
  }, [_c('paginate', {
    attrs: {
      "name": "filterResults",
      "tag": "div",
      "list": _vm.filterResults,
      "per": 30
    }
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover mb-0 table-sm"
  }, [_c('thead', {
    staticClass: "bg-darkgrey"
  }, [_c('tr', [_c('th', {
    staticClass: "sortable nowrap",
    on: {
      "click": function($event) {
        _vm.sortBy('name', false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('AddressBook.name'))), (_vm.sort.current === 'name') ? _c('i', {
    staticClass: "ml-1 fa",
    class: {
      'fa-arrow-down': _vm.sort.desc, 'fa-arrow-up': !_vm.sort.desc
    },
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "sortable nowrap",
    on: {
      "click": function($event) {
        _vm.sortBy('address', false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('AddressBook.address'))), (_vm.sort.current === 'address') ? _c('i', {
    staticClass: "ml-1 fa",
    class: {
      'fa-arrow-down': _vm.sort.desc, 'fa-arrow-up': !_vm.sort.desc
    },
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "sortable nowrap",
    on: {
      "click": function($event) {
        _vm.sortBy('phone', false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('AddressBook.phone'))), (_vm.sort.current === 'phone') ? _c('i', {
    staticClass: "ml-1 fa",
    class: {
      'fa-arrow-down': _vm.sort.desc, 'fa-arrow-up': !_vm.sort.desc
    },
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "sortable nowrap",
    on: {
      "click": function($event) {
        _vm.sortBy('fax', false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('AddressBook.fax'))), (_vm.sort.current === 'fax') ? _c('i', {
    staticClass: "ml-1 fa",
    class: {
      'fa-arrow-down': _vm.sort.desc, 'fa-arrow-up': !_vm.sort.desc
    },
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "sortable nowrap",
    on: {
      "click": function($event) {
        _vm.sortBy('email', false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('AddressBook.email'))), (_vm.sort.current === 'email') ? _c('i', {
    staticClass: "ml-1 fa",
    class: {
      'fa-arrow-down': _vm.sort.desc, 'fa-arrow-up': !_vm.sort.desc
    },
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "sortable nowrap",
    on: {
      "click": function($event) {
        _vm.sortBy('contact', false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('AddressBook.contact'))), (_vm.sort.current === 'contact') ? _c('i', {
    staticClass: "ml-1 fa",
    class: {
      'fa-arrow-down': _vm.sort.desc, 'fa-arrow-up': !_vm.sort.desc
    },
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('transition-group', {
    attrs: {
      "name": "fade",
      "tag": "tbody"
    }
  }, [_c('tr', {
    key: "filter"
  }, [_c('td', [_c('regular-input', {
    attrs: {
      "value": _vm.fields.name,
      "placeholder": _vm.$t('AddressBook.name')
    },
    on: {
      "input": function($event) {
        _vm.fields.name = $event;
        _vm.filteredSearchMethod()
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('regular-input', {
    attrs: {
      "value": _vm.fields.address,
      "placeholder": _vm.$t('AddressBook.address')
    },
    on: {
      "input": function($event) {
        _vm.fields.address = $event;
        _vm.filteredSearchMethod()
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('regular-input', {
    attrs: {
      "value": _vm.fields.phone,
      "placeholder": _vm.$t('AddressBook.phone')
    },
    on: {
      "input": function($event) {
        _vm.fields.phone = $event;
        _vm.filteredSearchMethod()
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('regular-input', {
    attrs: {
      "value": _vm.fields.fax,
      "placeholder": _vm.$t('AddressBook.fax')
    },
    on: {
      "input": function($event) {
        _vm.fields.fax = $event;
        _vm.filteredSearchMethod()
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('regular-input', {
    attrs: {
      "value": _vm.fields.email,
      "placeholder": _vm.$t('AddressBook.email')
    },
    on: {
      "input": function($event) {
        _vm.fields.email = $event;
        _vm.filteredSearchMethod()
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('regular-input', {
    attrs: {
      "value": _vm.fields.contact,
      "placeholder": _vm.$t('AddressBook.contact')
    },
    on: {
      "input": function($event) {
        _vm.fields.contact = $event;
        _vm.filteredSearchMethod()
      }
    }
  })], 1), _vm._v(" "), _c('th')]), _vm._v(" "), _vm._l((_vm.paginated('filterResults')), function(customer) {
    return _c('tr', {
      key: customer['.key']
    }, [_c('td', {
      staticClass: "nowrap"
    }, [_c('p', {
      staticClass: "table-fix-width"
    }, [_vm._v(_vm._s(customer.name))])]), _vm._v(" "), _c('td', {
      staticClass: "nowrap"
    }, [_vm._v(_vm._s(customer.address))]), _vm._v(" "), _c('td', {
      staticClass: "nowrap"
    }, [_vm._v(_vm._s(customer.phone))]), _vm._v(" "), _c('td', {
      staticClass: "nowrap"
    }, [_vm._v(_vm._s(customer.fax))]), _vm._v(" "), _c('td', {
      staticClass: "nowrap"
    }, [_vm._v(_vm._s(customer.email))]), _vm._v(" "), _c('td', {
      staticClass: "nowrap"
    }, [_vm._v(_vm._s(customer.contact))]), _vm._v(" "), _c('td', [_c('input', {
      staticClass: "btn btn-kne-orange pull-right",
      attrs: {
        "type": "button",
        "value": _vm.$t('AddressBook.modify')
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.modifying(customer)
        }
      }
    })])])
  })], 2)], 1)])]), _vm._v(" "), _c('paginate-links', {
    attrs: {
      "for": "filterResults",
      "hide-single-page": true,
      "limit": 5
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.current === 'sageOne') ? _c('div', {
    key: "sageOne",
    staticClass: "card"
  }, [_c('paginate', {
    attrs: {
      "name": "filterResultsSageOne",
      "tag": "div",
      "list": _vm.filterResultsSageOne,
      "per": 30
    }
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover mb-0 table-sm"
  }, [_c('thead', {
    staticClass: "bg-darkgrey"
  }, [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('AddressBook.name')))]), _vm._v(" "), _c('th', [_c('a', {
    staticClass: "btn btn-sm btn-kne-orange pull-right",
    attrs: {
      "target": "_blank",
      "href": 'https://mysageone.ca.sageone.com/oauth2/auth?response_type=code&client_id=3ff1477e6ec457b7df62&redirect_uri=https://systems.keepneye.com/sageone/SageoneToken&scope=full_access&transpuid='
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])]), _vm._v(" "), _c('transition-group', {
    attrs: {
      "name": "fade",
      "tag": "tbody"
    }
  }, [_c('tr', {
    key: "filter"
  }, [_c('td', [_c('regular-input', {
    attrs: {
      "value": _vm.sageOneNameFilter,
      "placeholder": _vm.$t('AddressBook.name')
    },
    on: {
      "input": function($event) {
        _vm.sageOneNameFilter = $event;
        _vm.filteredSearchMethodSage()
      }
    }
  })], 1), _vm._v(" "), _c('th')]), _vm._v(" "), _vm._l((_vm.paginated('filterResultsSageOne')), function(customer) {
    return _c('tr', {
      key: customer['.key'],
      class: {
        'linked': customer.C
      }
    }, [_c('td', {
      staticClass: "nowrap"
    }, [_vm._v(_vm._s(customer.A || customer.name))]), _vm._v(" "), _c('td', [_c('input', {
      staticClass: "btn btn-kne-orange pull-right",
      attrs: {
        "type": "button",
        "value": _vm.$t('AddressBook.modify')
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.modifyingSage(customer)
        }
      }
    })])])
  })], 2)], 1)])]), _vm._v(" "), _c('paginate-links', {
    attrs: {
      "for": "filterResultsSageOne",
      "hide-single-page": true,
      "limit": 5
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.current === 'linkTrans') ? _c('div', {
    key: "linkTrans",
    staticClass: "card"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover mb-0 table-sm"
  }, [_c('thead', {
    staticClass: "bg-darkgrey"
  }, [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('AddressBook.name')))]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('transition-group', {
    attrs: {
      "name": "fade",
      "tag": "tbody"
    }
  }, _vm._l((_vm.trans), function(t) {
    return _c('tr', {
      key: t['.key'],
      class: {
        'linked': t.linked
      }
    }, [_c('td', {
      staticClass: "nowrap"
    }, [_vm._v(_vm._s(t.name))]), _vm._v(" "), _c('td', [_c('input', {
      staticClass: "btn btn-kne-orange pull-right",
      attrs: {
        "type": "button",
        "value": _vm.$t('AddressBook.modify')
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.modifyingTransDealSage(t, 'transporter')
        }
      }
    })])])
  }))], 1)])]) : _vm._e(), _vm._v(" "), (_vm.current === 'linkDeal') ? _c('div', {
    key: "linkDeal",
    staticClass: "card"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover mb-0 table-sm"
  }, [_c('thead', {
    staticClass: "bg-darkgrey"
  }, [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('AddressBook.name')))]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('transition-group', {
    attrs: {
      "name": "fade",
      "tag": "tbody"
    }
  }, _vm._l((_vm.deal), function(d) {
    return _c('tr', {
      key: d['.key'],
      class: {
        'linked': d.linked
      }
    }, [_c('td', {
      staticClass: "nowrap"
    }, [_vm._v(_vm._s(d.name))]), _vm._v(" "), _c('td', [_c('input', {
      staticClass: "btn btn-kne-orange pull-right",
      attrs: {
        "type": "button",
        "value": _vm.$t('AddressBook.modify')
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.modifyingTransDealSage(d, 'dealer')
        }
      }
    })])])
  }))], 1)])]) : _vm._e()])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.modifySage) ? _c('modal', {
    attrs: {
      "closable": ""
    },
    on: {
      "close-request": function($event) {
        _vm.modifySage = false
      }
    }
  }, [_c('h4', {
    staticClass: "kne-title mx-3"
  }, [_vm._v(_vm._s(_vm.$t('AddressBook.sageone_change_title')))]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_vm._v(_vm._s(_vm.sageOneChange.target.A || _vm.sageOneChange.target.name))]), _vm._v(" "), _c('regular-datalist', {
    staticClass: "col-12 form-group datalist",
    attrs: {
      "multiSelect": "",
      "value": _vm.datalist.name,
      "secondList": _vm.customers,
      "thirdList": _vm.dealerTrans
    },
    on: {
      "input": function($event) {
        _vm.setSage($event)
      }
    }
  }), _vm._v(" "), _c('transition-group', {
    staticClass: "container-fluid",
    attrs: {
      "tag": "div",
      "name": "fade",
      "id": "multi"
    }
  }, _vm._l((_vm.sageCustomer), function(customer, index) {
    return (customer.key) ? _c('span', {
      key: customer.key,
      staticClass: "badge badge-kne mr-2"
    }, [_vm._v("\n          " + _vm._s(customer.value) + "\n          "), _c('i', {
      staticClass: "fa fa-times fa-lg p-1 delete",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          _vm.sageCustomer.splice(index, 1)
        }
      }
    })]) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "col-12 mt-3"
  }, [_c('input', {
    staticClass: "btn btn-kne-orange pull-right",
    attrs: {
      "disabled": _vm.sageCustomer.length < 1,
      "type": "button",
      "value": _vm.$t('AddressBook.modifySageSubmit')
    },
    on: {
      "click": function($event) {
        _vm.SubmitmodifySage()
      }
    }
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.modifySageDealTrans) ? _c('modal', {
    attrs: {
      "closable": ""
    },
    on: {
      "close-request": function($event) {
        _vm.modifySageDealTrans = false
      }
    }
  }, [_c('h4', {
    staticClass: "kne-title mx-3"
  }, [_vm._v(_vm._s(_vm.$t('AddressBook.sageone_change_title')))]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_vm._v(_vm._s(_vm.sageOneChange.target.name))]), _vm._v(" "), _c('regular-datalist', {
    staticClass: "col-12 form-group datalist",
    attrs: {
      "value": _vm.datalist.name,
      "sageOne": _vm.sageone
    },
    on: {
      "input": function($event) {
        _vm.datalist.name = $event.value;
        _vm.datalist.key = $event.key
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12 mt-3"
  }, [_c('input', {
    staticClass: "btn btn-kne-orange pull-right",
    attrs: {
      "disabled": _vm.datalist.key === null,
      "type": "button",
      "value": _vm.$t('AddressBook.modifySageSubmit')
    },
    on: {
      "click": function($event) {
        _vm.SubmitmodifyTransDealSage()
      }
    }
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.add === true || _vm.modify === true) ? _c('modal', {
    attrs: {
      "closable": ""
    },
    on: {
      "close-request": function($event) {
        _vm.add = false;
        _vm.modify = false
      }
    }
  }, [(_vm.add) ? _c('h4', {
    staticClass: "kne-title mx-3"
  }, [_vm._v(_vm._s(_vm.$t('AddressBook.addTitle')))]) : _c('h4', {
    staticClass: "kne-title mx-3"
  }, [_vm._v(_vm._s(_vm.$t('AddressBook.modifyTitle')))]), _vm._v(" "), _c('div', {}, [_c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.customer.name,
      "type": "text",
      "placeholder": _vm.$t('AddressBook.name') + '*'
    },
    on: {
      "input": function($event) {
        _vm.customer.name = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.customer.address,
      "type": "text",
      "placeholder": _vm.$t('AddressBook.address') + '*'
    },
    on: {
      "input": function($event) {
        _vm.customer.address = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.customer.postcode,
      "type": "text",
      "placeholder": _vm.$t('AddressBook.postCode') + '*'
    },
    on: {
      "input": function($event) {
        _vm.customer.postcode = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.customer.phone,
      "type": "text",
      "placeholder": _vm.$t('AddressBook.phone') + '*'
    },
    on: {
      "input": function($event) {
        _vm.customer.phone = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.customer.city,
      "type": "text",
      "placeholder": _vm.$t('AddressBook.city')
    },
    on: {
      "input": function($event) {
        _vm.customer.city = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.customer.province,
      "placeholder": _vm.$t('AddressBook.province')
    },
    on: {
      "change": function($event) {
        _vm.customer.province = $event
      }
    }
  }), _vm._v(" "), _c('regular-select', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.customer.country,
      "placeholder": _vm.$t('AddressBook.country')
    },
    on: {
      "change": function($event) {
        _vm.customer.country = $event
      }
    }
  }, [_c('option', [_vm._v("Canada")]), _vm._v(" "), _c('option', [_vm._v("US")])]), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.customer.email,
      "type": "text",
      "placeholder": _vm.$t('AddressBook.email')
    },
    on: {
      "input": function($event) {
        _vm.customer.email = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.customer.receptionEmail,
      "type": "text",
      "placeholder": _vm.$t('AddressBook.receptionEmail')
    },
    on: {
      "input": function($event) {
        _vm.customer.receptionEmail = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.customer.fax,
      "type": "text",
      "placeholder": _vm.$t('AddressBook.fax')
    },
    on: {
      "input": function($event) {
        _vm.customer.fax = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.customer.contact,
      "type": "text",
      "placeholder": _vm.$t('AddressBook.contact')
    },
    on: {
      "input": function($event) {
        _vm.customer.contact = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.customer.sageID,
      "type": "text",
      "disabled": true,
      "placeholder": _vm.$t('AddressBook.sageID')
    },
    on: {
      "input": function($event) {
        _vm.customer.sageID = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.customer.comments,
      "type": "text",
      "placeholder": _vm.$t('AddressBook.comments')
    },
    on: {
      "input": function($event) {
        _vm.customer.comments = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [(_vm.add) ? _c('button', {
    staticClass: "btn btn-kne-orange w-100",
    attrs: {
      "disabled": !_vm.customerFilledForm
    },
    on: {
      "click": function($event) {
        _vm.addCustomer()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('AddressBook.addSubmit')))]) : _c('button', {
    staticClass: "btn btn-kne-orange w-100",
    attrs: {
      "disabled": !_vm.customerFilledForm
    },
    on: {
      "click": function($event) {
        _vm.modifyCustomer()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('AddressBook.modifySubmit')))])]), _vm._v(" "), (_vm.modify && _vm.isAdmin) ? _c('h4', {
    staticClass: "kne-title mx-3 mt-3"
  }, [_vm._v(_vm._s(_vm.$t('AddressBook.deleteTitle')))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [(_vm.modify && _vm.isAdmin) ? _c('button', {
    staticClass: "btn btn-danger w-100",
    on: {
      "click": function($event) {
        _vm.deleteCustomer()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('AddressBook.deleteUser')))]) : _vm._e()])]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b40362dc","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/AddressBook.vue
// module id = 849
// module chunks = 1